import { Button } from "@/components/ui/button";
import NewButton from "@/components/layout/new-button";
import { HeaderSearchBar, HeaderSearchIcon } from "@/components/layout/header-search";
import { Menu } from "lucide-react";

interface HeaderProps {
  title: string;
  subtitle?: string;
  currentPage?: string;
  onMenuToggle?: () => void;
  icon?: React.ReactNode;
  pageActions?: React.ReactNode;
}

export default function Header({ title, subtitle, currentPage, onMenuToggle, icon, pageActions }: HeaderProps) {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="px-4 sm:px-6 py-4">
        <div className="flex items-center gap-3">
          {/* Left: menu toggle + icon + title */}
          <div className="flex items-center gap-3 min-w-0 shrink">
            {onMenuToggle && (
              <Button
                variant="ghost"
                size="sm"
                onClick={onMenuToggle}
                className="md:hidden shrink-0"
              >
                <Menu className="w-5 h-5" />
              </Button>
            )}
            {icon && <div className="hidden sm:block shrink-0">{icon}</div>}
            <div className="min-w-0">
              <h1 className="text-xl sm:text-2xl font-bold text-gray-900 truncate">{title}</h1>
              {subtitle && <p className="text-sm text-gray-600 hidden sm:block truncate">{subtitle}</p>}
            </div>
          </div>

          {/* Center: full search bar, desktop only (md+) */}
          <div className="hidden md:flex flex-1 justify-center px-4">
            <div style={{ minWidth: "200px", maxWidth: "320px", width: "100%" }}>
              <HeaderSearchBar />
            </div>
          </div>

          {/* Right: search icon (mobile), page actions, new button */}
          <div className="flex items-center gap-2 sm:gap-3 shrink-0 ml-auto md:ml-0">
            <HeaderSearchIcon />
            {pageActions}
            <NewButton currentPage={currentPage} />
          </div>
        </div>
      </div>
    </header>
  );
}
